var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useEffect, useState } from 'react';
import { transformSessionResponse } from '../utils/sessionUtils';
import analytics from '../analytics';
import { BrowserStorage } from '../utils/browserStorage';
import useRefreshSessionAccess from './UseRefreshSessionAccess';
/**
 * usePromptRetrieval
 * @public
 */
const usePromptRetrieval = args => {
  const [statusMsg, setStatusMesg] = useState('');
  const [tabVisible, setTabVisible] = useState(false);
  const {
    retrieveUrl,
    cguid,
    setRetrievalLoading,
    setPrompts,
    setCachedPrompts,
    setCachedMessages,
    setChatMessages,
    setLastPromptId,
    limit = 5,
    isSessionActive,
    productId = 0,
    requestFrom = ''
  } = args;
  useRefreshSessionAccess();
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setTabVisible(true);
      } else {
        setTabVisible(false);
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  useEffect(() => {
    const browserStorage = new BrowserStorage();
    const abortController = new AbortController();
    setTimeout(() => {
      abortController.abort();
    }, 30000); // 30 seconds timeout for fetch request /
    const fetchMe = () => __awaiter(void 0, void 0, void 0, function* () {
      var _a;
      const pennysid = (_a = browserStorage.getItem('pennysid')) !== null && _a !== void 0 ? _a : '';
      const baseUrl = retrieveUrl ? retrieveUrl : '/genai-svc/genai/chat/retrieve-prompts';
      return yield fetch(baseUrl, {
        method: 'POST',
        signal: abortController.signal,
        body: JSON.stringify({
          pennysid,
          cguid,
          limit,
          isSessionActive,
          productId,
          requestFrom
        })
      });
    });
    if (isSessionActive) {
      setRetrievalLoading(true);
      fetchMe().then(result => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const sessionResult = yield result === null || result === void 0 ? void 0 : result.json();
        if (sessionResult === null || sessionResult === void 0 ? void 0 : sessionResult.token) {
          sessionStorage.setItem('pennysid', sessionResult.token);
        } else {
          analytics.log({
            source: 'usePromptRetrieval',
            message: `Invalid token sent, token is ${sessionResult === null || sessionResult === void 0 ? void 0 : sessionResult.token}`
          });
        }
        const sessionData = sessionResult.data;
        if (sessionData === null || sessionData === void 0 ? void 0 : sessionData.length) {
          const sessionChatMessage = sessionData.map(item => transformSessionResponse(item));
          const sessionChatPrompt = sessionData.map(item => {
            const obj = {
              role: item.role,
              content: item.content
            };
            setCachedPrompts(obj);
            setCachedMessages(transformSessionResponse(item));
            return obj;
          });
          setLastPromptId((_b = sessionData[0]) === null || _b === void 0 ? void 0 : _b.promptId);
          const combinedPrompts = [...sessionChatPrompt];
          setChatMessages(sessionChatMessage);
          setPrompts(combinedPrompts);
          setStatusMesg('Success');
        }
      })).catch(e => {
        setStatusMesg('Failed');
        analytics.log({
          source: 'Chatbot retrieve error',
          message: e.message
        });
      }).finally(() => setRetrievalLoading(false));
    }
  }, [isSessionActive, tabVisible]);
  return {
    statusMsg
  };
};
export default usePromptRetrieval;